import type { HsGraphics } from '../../graphic-render-new/graphics.class';
import type { HsRegularGeometry } from '../../graphic-engine-new/geometry/regular-geometry.class';
import { HsDefaultMaterial } from '../../graphic-render-new/materials/default-material.class';
import type { HsMaterial } from '../../graphic-render-new/materials/material.class';
import type { HsGraphicLines } from '../../graphic-render-new/objects/graphic-lines.class';
import { HsShaderData } from '../../graphic-render-new/shaders/classes/shader-data.class';
import type { HsShader } from '../../graphic-render-new/shaders/classes/shader.class';
import { HsShaderObjectType } from '../../graphic-render-new/shaders/enums/shader-object-type.enum';
import type { HsColor } from '../../math-new/objects/color.class';

/**
 * Handles s helper.
 */
export abstract class HsHelper {
  protected geometry: HsRegularGeometry | null = null;
  protected material: HsMaterial | null = null;

  public abstract makeLines(): HsGraphicLines;

  protected makeMaterial(gl: WebGL2RenderingContext, color: HsColor): void {
    if (this.material !== null) {
      return;
    }
    const shaderData: HsShaderData = new HsShaderData(HsShaderObjectType.single);
    shaderData.addColor().addDepth();
    const shader: HsShader = shaderData.makeShader();
    this.material = new HsDefaultMaterial(gl, shader);
    this.material.color.copy(color);
  }

  public dispose(graphics: HsGraphics): void {
    if (this.geometry !== null) {
      graphics.deleteBuffer(this.geometry.buffer);
    }
  }
}
